import RestService from 'services/RestService';

export const getApplePayPaymentSession = (paymentId: string) =>
  RestService.getNotCache(`/paywalldata/payments/${paymentId}/applepay/v2/session`);

export const getApplePayPaymentConfig = (paymentId: string) =>
  RestService.get(`/paywalldata/payments/${paymentId}/applepay/config`);

export const getAllPaymentData = (paymentId: string, isApplePaySupported: boolean, fingerprint?: string) =>
  RestService.getNotCache(
    `/paywalldata/payments/${paymentId}?applePayEnabled=${isApplePaySupported}`,
    undefined,
    undefined,
    fingerprint
  );

export const getProviderPayment = (paymentId: string, token: string) =>
  RestService.get(`/payment/post_initialize/${paymentId}?token=${token}`);

export const getPaymentDetails = (paymentId: string) => RestService.get(`/paywalldata/payments/${paymentId}/details`);

export const getPaymentStatus = (paymentId: string) => RestService.get(`/paywalldata/payments/${paymentId}/status`);

export const checkIfPaymentExists = (paymentId: string) => RestService.get(`/paywalldata/payments/${paymentId}/exists`);

export const getGooglePayConfiguration = (paymentId: string, pmpt?: number) =>
  RestService.get(`/paywalldata/payments/${paymentId}/googlepay/config?pmpt=${pmpt}`);

export const getWorldlineConfiguration = (paymentId: string) =>
  RestService.get(`/paywalldata/payments/${paymentId}/worldline/config`);

export const updatePayment = (
  paymentId: maybe<string>,
  paymentData: {
    paymentMethodId: string;
    authorizationCode?: string;
    paymentMethodToken?: string;
    locale?: string;
    pmpt?: number;
    saveInstrument?: boolean;
    tokenizedPayment?: boolean;
  }
) => RestService.patch(`/paywalldata/payments/${paymentId}`, paymentData);

export const preInit = (paymentId: maybe<string>, metrics: unknown) =>
  RestService.post(`/paywalldata/payments/${paymentId}/preinit`, metrics as IUrlParams);

export const recoveryPayment = (paymentId: string) => RestService.post(`/paywalldata/payments/${paymentId}/recovery`);

export const getRecoverPayment = (paymentId: string) => RestService.get(`/paywalldata/payments/${paymentId}/recovery`);

export const deleteSavedCard = (paymentId: string, token: string) =>
  RestService.delete(`/paywalldata/payments/${paymentId}/card?tokenId=${token}`);
